import { Field, Select } from "@/components/FormField";

const TRANSPORT_OPTIONS = ["Yes", "No", "Need quotation"];
const YES_NO = ["Yes", "No"];

export default function BulkPurchaseFields({ extra, updExtra }) {
  return (
    <>
      <div className="text-sm font-semibold text-[var(--yp-primary)] sm:col-span-2 -mb-2">Bulk Purchase Information</div>
      <Field id="sr-bulk-plant" label="Plant / variety" value={extra.bulk_plant || ""} onChange={(v) => updExtra("bulk_plant", v)} />
      <Field id="sr-bulk-qty" label="Quantity" type="number" value={extra.bulk_qty || ""} onChange={(v) => updExtra("bulk_qty", v)} />
      <Field id="sr-bulk-size" label="Required size / height" value={extra.bulk_size || ""} onChange={(v) => updExtra("bulk_size", v)} />
      <Field id="sr-bulk-bag" label="Pot / bag size" value={extra.bag_size || ""} onChange={(v) => updExtra("bag_size", v)} />
      <Select id="sr-bulk-transport" label="Transport required?" value={extra.transport || ""} onChange={(v) => updExtra("transport", v)} options={TRANSPORT_OPTIONS} />
      <Select id="sr-bulk-gst" label="GST invoice required?" value={extra.gst_invoice || ""} onChange={(v) => updExtra("gst_invoice", v)} options={YES_NO} />
    </>
  );
}
